<top-banner class="notice" *ngIf="hasNoAssignedElds">
  <ng-container i18n>Your fleet has {{unassignedElds}} {{unassignedElds > 1 ? 'Vehicle Gateways' : 'Vehicle Gateway'}} that need to be
    assigned to vehicles before you get started on Motive Vehicle Gateways.</ng-container>
  <a href="{{installAndAssignTheELDUrl}}" target="_blank" i18n>
    Click here to learn how.
  </a>
</top-banner>

<top-banner *ngIf="hasNoEldDrivers" class="notice" closable (onClose)="onBannerClose.emit()">
  <ng-container i18n>To use your new Vehicle Gateways, you need to enable your drivers to use them.</ng-container>
  <a href="{{addDriverToYourCompanyArticleUrl}}" target="_blank" i18n>
    Click here to learn how.
  </a>
</top-banner>
